// 搜索适配参数
const searchForm = {
  data() {
    return {
      searchItemLayout: {
        labelCol: {
          span: 9
        },
        wrapperCol: {
          span: 15
        }
      }
    }
  },
  methods: {}
}
export default searchForm